// UpgradeResult.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authManager } from '@/managers/AuthManager';
import { Loader2 } from 'lucide-react';

export const UpgradeResult = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const refreshAndRedirect = async () => {
      try {
        // Force token refresh to get new claims
        const user = authManager.getCurrentUser();
        if (user) {
          await user.getIdToken(true);
        }
        
        // Extended delay to ensure claims fully propagate
        setTimeout(() => {
          navigate('/dashboard');
        }, 5000);
      } catch (err) {
        setError(err.message);
        setTimeout(() => navigate('/dashboard'), 6000);
      }
    };

    refreshAndRedirect();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <p className="text-red-500">{error}</p>
          <p className="text-sm text-on-surface/60">Redirecting back to dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" />
        <p className="text-on-surface">Updating your subscription status...</p>
      </div>
    </div>
  );
};

export default UpgradeResult;